import { createConsumer } from '@rails/actioncable';

import getCookieValue from '~/utils/getCookieValue';

export const createCommunityConsumer = () => {
  // Browser-only: the consumer reads window/document. Callers may run during SSR
  // (a useMemo, not just a useEffect), so bail on the server rather than crash.
  if (typeof window === 'undefined') return null;

  const token =
    new URLSearchParams(window.location.search).get('jwt_token') || getCookieValue('token', document.cookie);
  if (!token) return null;

  const baseUrl = window.__AppGlobals__?.CABLE_URL;
  if (!baseUrl) return null;

  const wsProtocol = baseUrl.startsWith('https') ? 'wss' : 'ws';
  const wsBaseUrl = baseUrl.replace(/^https?/, wsProtocol);

  return createConsumer(`${wsBaseUrl}/orchid_cable?token=${encodeURIComponent(token)}`);
};
